export const BUDGET = verba => `/budget/${verba}/`;
export const PUT_BUDGET = verba => `/budget/${verba}/`;
